/* eslint-disable */
import axios from 'axios';

const apiInstance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL
});

const api = {
    getViews() {
        return apiInstance.get('/views')
    },
    getCategories() {
        return apiInstance.get('/categories')
    },
    getApplications() {
        return apiInstance.get('/apps')
    },
    getOfferings() {
        return apiInstance.get('/offerings')
    },
    postTransaction(payload) {
        return apiInstance.post('/transaction', payload)
    },
    getSearchResults(term) {
        return apiInstance.get('/search?q='+term)
    },
    getErrorMessages() {
        return apiInstance.get('/errors')
    },
    postAction(payload) {
        return apiInstance.post('/actions', payload)
    },
    getDownload(params) {          
        return apiInstance.get('/downloads?params='+params)
    },
    getFavorites() {
        return apiInstance.get('/favorites')
    },
    deleteFavorite(id) {
        return apiInstance.delete('/favorites/'+id)
    },
    postFavorite(payload) {
        return apiInstance.post('/favorites', payload)
    },
    getStats() {
        return apiInstance.get('/easier-3-stats')
    },
    refreshStats() {
        return apiInstance.post('/easier-3-stats')
    },
    getApiInstance() {
      return apiInstance;
    }
};

export default api;
